module.exports = __webpack_public_path__ + "img/confirm.e92dc2f2.png";